export default function defer(callback: any) {
  return undefer.bind(null, setTimeout(callback));
}

function undefer(timeoutId) {
  return clearTimeout(timeoutId);
}
